import {Analytics} from '../helpers/analytics';
import {breakpoints} from '../helpers/constants';

export class Toggler {
	constructor(elem, options) {
		this.elem = elem;
		this.options = options;

		this.layover = options ? options.layover : false;

		const toggleSelector = this.elem.dataset.toggle;
		this.toggleElement = document.querySelector(`[${toggleSelector}]`);

		this.toggleGroups = document.querySelectorAll('[data-toggle-group]');

		this.toggleGroupParent = this.getToggleGroupElement();

		this.addEventListeners();
	}

	get classNames() {
		return {
			ACTIVE: '_is-active',
			TOGGLED: '_has-toggled',
			EXPANDED: '_is-expanded'
		}
	}

	addEventListeners() {
		this.elem.addEventListener('click', (e) => {
			e.preventDefault();
			const target = e.currentTarget;

			const analyticsCategory = target.getAttribute(Analytics.analyticsTags.component);

			if (this.toggleGroupParent && !this.toggleElement.classList.contains(this.classNames.ACTIVE)) {
				const elementsWithActiveClass = this.toggleGroupParent.querySelectorAll(`.${this.classNames.ACTIVE}, .${this.classNames.TOGGLED}`);
				for (let i = 0; i < elementsWithActiveClass.length; i++) {
					elementsWithActiveClass[i].classList.remove(this.classNames.ACTIVE);
					elementsWithActiveClass[i].classList.remove(this.classNames.TOGGLED);
				}
				this.toggleElement.classList.add(this.classNames.ACTIVE);
				this.toggleElement.parentElement.classList.add(this.classNames.TOGGLED);
				this.handleAnalytics(analyticsCategory, target);
			} else {
				this.toggleElement.classList.toggle(this.classNames.ACTIVE);
				this.toggleElement.parentElement.classList.toggle(this.classNames.TOGGLED);
				if(this.layover){
					document.body.classList.toggle('overflow-hidden');
					document.getElementsByTagName('html')[0].classList.toggle('overflow-hidden');
				}
				this.handleAnalytics(analyticsCategory, target);
			}
		});
	}

	handleAnalytics(analyticsCategory, target) {
		let analyticsData = {};
		// On jobboard the mobile toggler is Accordion (accordion.js), and on desktop we use Toggler (toggler.js)
		const isAccordion = this.isAccordion(target);
		let expanded;
		if(isAccordion && breakpoints.isMedium()){
			expanded = target.parentElement.classList.contains(this.classNames.EXPANDED);
		}else{
			expanded = this.toggleElement.classList.contains(this.classNames.ACTIVE);
		}

		if (analyticsCategory) {
			analyticsData = {
				category: analyticsCategory,
				action: target.getAttribute(Analytics.analyticsTags.action),
				label: expanded ? 'expand' : 'collapse'
			};
			Analytics.measure(analyticsData);
		}
	}

	isAccordion(target){
		return target.getAttribute('data-accordion-header') !== null;
	}

	getToggleGroupElement() {
		let singleToggleGroupElement = [];
		for (let i = 0; i < this.toggleGroups.length; i++) {
			const elementsInsideTogglegroup = this.toggleGroups[i].querySelectorAll(Toggler.getSelector());
			singleToggleGroupElement = [elementsInsideTogglegroup, i];
		}

		let test = singleToggleGroupElement.length ? singleToggleGroupElement[0] : [];

		for (let j = 0; j < test.length; j++) {
			if (test[j] === this.elem) {
				return this.toggleGroups[singleToggleGroupElement[1]];
			}
		}
	}

	static getSelector() {
		return '[data-toggle]';
	}
}
